// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"19351e4a","668":"5c58a7fe","838":"0669664a"}[chunkId] + ".js";
};